export const name = 'richTextBox' as const
